var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.7301C12 20.1118 12.286 19.5283 12.7746 19.1495L22.061 11.95C22.7823 11.3909 23.7906 11.3909 24.5118 11.95L33.7982 19.1495C34.2869 19.5283 34.5728 20.1118 34.5728 20.7301V33.5C34.5728 34.163 34.3086 34.7989 33.8382 35.2678C33.3679 35.7366 32.7299 36 32.0647 36H29.0485C27.944 36 27.0485 35.1046 27.0485 34V25.6214C27.0485 24.5168 26.1531 23.6214 25.0485 23.6214H21.5243C20.4197 23.6214 19.5243 24.5168 19.5243 25.6214V34C19.5243 35.1046 18.6288 36 17.5243 36H14.5081C13.8429 36 13.205 35.7366 12.7346 35.2678C12.2642 34.7989 12 34.163 12 33.5V20.7301Z",
    fill: "#3361CF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.5,
    stroke: "#3361CF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.8d987f9ec0e5032c9f8b588bd8e9f0e0.svg";
export { ForwardRef as ReactComponent };